import { render, staticRenderFns } from "./Fans.vue?vue&type=template&id=ce773974&scoped=true&"
import script from "./Fans.vue?vue&type=script&lang=js&"
export * from "./Fans.vue?vue&type=script&lang=js&"
import style0 from "./Fans.vue?vue&type=style&index=0&id=ce773974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce773974",
  null
  
)

export default component.exports